import { SidebarModal } from '@domain-group/suit-theme'

import type { UseArtworkPayload } from '@hooks/useArtwork'

import EntityActivity from '@components/EntityActivity'

interface ActivityProps {
  artworkPayload: UseArtworkPayload,
}

const Activity = (props: ActivityProps) => {
  const {
    artworkPayload: {
      artwork,
    },
  } = props

  return (
    <SidebarModal.ExpandableSection
      label="Artwork Activity"
      title="View Activity"
      style={{ marginTop: 16 }}
    >
      <EntityActivity
        boxProps={{
          id: `artwork-${artwork.id}-activity`,
          minHeight: 470,
          padding: 'small',
        }}
        subjectId={artwork.id}
        subjectType="Artwork"
      />
    </SidebarModal.ExpandableSection>
  )
}

export default Activity
